import React from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

/**
 * Reusable Dashboard Settings Button Component
 * @param {Function} onClick - Handler for button click
 */
const DashboardSettingsButton = ({ onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  return (
    <Tooltip title={t('finance.fiStatement.dashboardSettings')}>
      <IconButton
        color="primary"
        onClick={onClick}
        sx={{
          backgroundColor: theme.palette.appBar.main,
          '&:hover': {
            backgroundColor: theme.palette.appBar.dark,
          },
        }}
      >
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  )
}

export default DashboardSettingsButton
